import { render, staticRenderFns } from "./MobileChangeLogCells.vue?vue&type=template&id=4baf1e38&scoped=true"
import script from "./MobileChangeLogCells.vue?vue&type=script&lang=js"
export * from "./MobileChangeLogCells.vue?vue&type=script&lang=js"
import style0 from "./MobileChangeLogCells.vue?vue&type=style&index=0&id=4baf1e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf1e38",
  null
  
)

export default component.exports